import { Typography } from '@mui/material'
import { useRecordContext } from 'react-admin'
import { BlogTitleProps } from './type'

export const BlogTitle: React.FC<BlogTitleProps> = ({ source, ...props }) => {
  const record = useRecordContext()
  return (
    <Typography variant='h3' {...props}>
      {record[source]}
    </Typography>
  )
}
